// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"593f0096","453":"83b3b875"}[chunkId] + ".chunk.js";
};